import { createReducer, on } from '@ngrx/store'
import { LpisDatasourceActions } from './action-types'

const INIT_STATE: ILpisDatasourceState = {
    filterArgs: []
}

export const lpisDatasourceReducer = createReducer(
    INIT_STATE,
    on(LpisDatasourceActions.setFilterArgs, (state, {args}): ILpisDatasourceState =>
       ({...state, filterArgs: args})
),
    on(LpisDatasourceActions.resetState, (): ILpisDatasourceState => INIT_STATE),
)

export interface ILpisDatasourceState {
    filterArgs: any;
}